var _ellipse, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 705,
    height: 900,
    viewBox: "0 0 705 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -92,
    y: -770,
    width: 797,
    height: 2394
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.5,
    cy: 427,
    rx: 398.5,
    ry: 1196.07,
    fill: "#1A1A1A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.648 -64.3126L336.495 -8.07518L381.104 27.0976L433.871 6.04106L442.024 -50.1964L397.408 -85.3701L344.648 -64.3126Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.408 -85.3701L336.495 -8.07524L433.871 6.04101L397.408 -85.3701Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.377 -81.8927L215.225 -25.6553L259.833 9.51752L312.601 -11.539L320.753 -67.7764L276.137 -102.95L223.377 -81.8927Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.167 -29.1554L579.014 27.082L623.623 62.2547L676.39 41.1982L684.543 -15.0392L639.927 -50.2129L587.167 -29.1554Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.927 -50.2129L579.014 27.0819L676.39 41.1982L639.927 -50.2129Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.896 -46.7355L457.744 9.50195L502.352 44.6747L555.12 23.6182L563.272 -32.6192L518.656 -67.793L465.896 -46.7355Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.416 -11.5783L700.263 44.6592L744.872 79.8319L797.639 58.7754L805.792 2.53799L761.176 -32.6358L708.416 -11.5783Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.688 6.72452L556.321 -29.843",
    stroke: "#FF7300",
    strokeWidth: 0.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5571 111.415L63.4056 167.645L108.013 202.825L160.774 181.761L168.926 125.53L124.317 90.3574L71.5571 111.415Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.317 90.3574L63.4056 167.645L160.774 181.76L124.317 90.3574Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.076 146.572L305.925 202.802L350.532 237.982L403.301 216.919L411.452 160.688L366.836 125.515L314.076 146.572Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.836 125.515L305.925 202.802L403.301 216.919L366.836 125.515Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.806 128.992L184.654 185.222L229.262 220.402L282.03 199.339L290.182 143.108L245.566 107.935L192.806 128.992Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.695 209.991L219.142 118.34",
    stroke: "#FF7300",
    strokeWidth: 0.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.7133 93.8349L-57.8648 150.065L-13.2571 185.245L39.5113 164.181L47.6628 107.951L3.04693 72.7773L-49.7133 93.8349Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.9213 147.295L40.7122 110.72",
    stroke: "#FF7300",
    strokeWidth: 0.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.932 22.8294L151.665 66.063L185.963 93.1098L226.537 76.9169L232.805 33.6833L198.499 6.63544L157.932 22.8294Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.499 6.63477L185.963 93.1091",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.665 66.0627L232.805 33.6831",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.537 76.9166L157.932 22.8291",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0118 -23.6494L62.7712 88.3809",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 53.3433L123.45 11.3893",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.33 67.4045L26.4537 -2.67188",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.451 57.9857L394.184 101.219L428.482 128.266L469.056 112.073L475.324 68.8396L441.018 41.7917L400.451 57.9857Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.018 41.792L428.482 128.266",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.184 101.22L475.323 68.8403",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.056 112.074L400.451 57.9863",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.531 11.5078L305.29 123.538",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.853 88.5005L365.969 46.5465",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.849 102.562L268.973 32.4854",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.595 181.729L548.444 237.96L593.051 273.14L645.82 252.076L653.971 195.846L609.356 160.672L556.595 181.729Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.356 160.672L548.444 237.96L645.82 252.076L609.356 160.672Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.844 199.307L669.693 255.537L714.3 290.717L767.069 269.653L775.22 213.423L730.604 178.249L677.844 199.307Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.733 280.305L704.18 188.654",
    stroke: "#FF7300",
    strokeWidth: 0.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.325 164.149L427.173 220.38L471.781 255.559L524.549 234.496L532.701 178.266L488.085 143.092L435.325 164.149Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.117 217.61L525.751 181.035",
    stroke: "#FF7300",
    strokeWidth: 0.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.971 93.1429L636.703 136.377L671.002 163.423L711.575 147.23L717.843 103.997L683.537 76.9489L642.971 93.1429Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.537 76.9492L671.001 163.424",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.703 136.377L717.843 103.998",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.575 147.231L642.97 93.1436",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.05 46.666L547.81 158.696",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.371 123.658L608.488 81.7038",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.368 137.719L511.492 67.6426",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9856 322.3L32.8341 378.53L77.4428 413.703L130.203 392.646L138.355 336.415L93.7469 301.235L40.9856 322.3Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7469 301.235L32.8342 378.53L130.203 392.645L93.7469 301.235Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-80.2847 304.72L-88.4362 360.95L-43.8275 396.123L8.93989 375.066L17.0914 318.836L-27.5234 283.655L-80.2847 304.72Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.505 357.457L275.353 413.687L319.962 448.86L372.729 427.804L380.881 371.574L336.266 336.393L283.505 357.457Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.266 336.393L275.353 413.687L372.729 427.804L336.266 336.393Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.235 339.877L154.083 396.107L198.692 431.28L251.459 410.224L259.611 353.993L214.996 318.812L162.235 339.877Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.123 420.876L188.571 329.225",
    stroke: "#FF7300",
    strokeWidth: 0.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-81.4916 358.173L10.141 321.605",
    stroke: "#FF7300",
    strokeWidth: 0.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.362 233.706L121.094 276.947L155.392 303.994L195.966 287.801L202.234 244.56L167.929 217.512L127.362 233.706Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.929 217.513L155.392 303.994",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.094 276.948L202.234 244.561",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.966 287.802L127.362 233.707",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4406 187.236L32.1999 299.266",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.238 264.228L92.8786 222.274",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7582 278.289L-4.11768 208.213",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.881 268.864L363.613 312.104L397.911 339.151L438.485 322.958L444.753 279.718L410.448 252.67L369.881 268.864Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.448 252.67L397.911 339.152",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.613 312.105L444.753 279.718",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.485 322.959L369.881 268.864",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.96 222.394L274.719 334.424",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.281 299.385L335.398 257.431",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.277 313.447L238.401 243.37",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.024 392.614L517.873 448.845L562.481 484.018L615.249 462.961L623.4 406.731L578.785 371.55L526.024 392.614Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.785 371.55L517.873 448.845L615.249 462.961L578.785 371.55Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.754 375.034L396.602 431.265L441.211 466.438L493.978 445.381L502.13 389.151L457.515 353.97L404.754 375.034Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.273 410.192L639.121 466.422L683.73 501.595L736.497 480.538L744.649 424.308L700.034 389.127L647.273 410.192Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.162 491.19L673.609 399.539",
    stroke: "#FF7300",
    strokeWidth: 0.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.547 428.487L495.179 391.92",
    stroke: "#FF7300",
    strokeWidth: 0.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.4 304.021L606.132 347.262L640.43 374.308L681.004 358.115L687.273 314.875L652.967 287.827L612.4 304.021Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.967 287.827L640.43 374.309",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.132 347.262L687.273 314.875",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.004 358.116L612.4 304.021",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.479 257.551L517.238 369.581",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.8 334.543L577.917 292.589",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.796 348.604L480.921 278.527",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2712 531.881L2.11971 588.111L46.7284 623.284L99.4885 602.226L107.64 545.996L63.0313 510.823L10.2712 531.881Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0313 510.823L2.1197 588.111L99.4885 602.226L63.0313 510.823Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.79 567.038L244.639 623.268L289.248 658.441L342.015 637.385L350.166 581.154L305.551 545.98L252.79 567.038Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.55 545.98L244.639 623.268L342.015 637.385L305.55 545.98Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.52 549.458L123.368 605.688L167.977 640.861L220.744 619.804L228.896 563.574L184.28 528.4L131.52 549.458Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.409 630.457L157.856 538.806",
    stroke: "#FF7300",
    strokeWidth: 0.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6474 443.288L90.379 486.529L124.677 513.576L165.251 497.383L171.52 454.142L137.213 427.101L96.6474 443.288Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.213 427.101L124.677 513.575",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3791 486.528L171.519 454.149",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.251 497.382L96.6465 443.295",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.726 396.816L1.48534 508.847",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-42.9525 473.809L62.164 431.855",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0437 487.87L-34.8322 417.794",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.167 478.445L332.898 521.686L367.197 548.733L407.77 532.54L414.039 489.299L379.732 462.258L339.167 478.445Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.732 462.258L367.196 548.732",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.898 521.686L414.038 489.306",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.77 532.54L339.166 478.452",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.245 431.974L244.005 544.004",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.567 508.966L304.683 467.012",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.563 523.028L207.687 452.951",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.31 602.195L487.158 658.425L531.767 693.598L584.534 672.542L592.686 616.311L548.07 581.138L495.31 602.195Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.07 581.138L487.158 658.425L584.534 672.542L548.07 581.138Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.558 619.772L608.407 676.003L653.015 711.175L705.783 690.119L713.934 633.889L669.318 598.715L616.558 619.772Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.447 700.771L642.894 609.12",
    stroke: "#FF7300",
    strokeWidth: 0.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.039 584.615L365.888 640.845L410.496 676.018L463.264 654.962L471.415 598.731L426.799 563.558L374.039 584.615Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.831 638.074L464.465 601.5",
    stroke: "#FF7300",
    strokeWidth: 0.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.686 513.602L575.417 556.842L609.716 583.889L650.29 567.696L656.558 524.455L622.251 497.415L581.686 513.602Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.252 497.415L609.716 583.889",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.418 556.843L656.557 524.463",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.29 567.697L581.685 513.609",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.764 467.131L486.524 579.161",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.086 544.124L547.202 502.17",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.082 558.185L450.206 488.108",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.605 579.281L789.721 537.327",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.601 593.342L692.725 523.266",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.2989 742.759L-28.4515 798.996L16.1572 834.169L68.9174 813.111L77.0699 756.874L32.4613 721.701L-20.2989 742.759Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4613 721.701L-28.4514 798.996L68.9174 813.111L32.4613 721.701Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.22 777.916L214.068 834.153L258.676 869.326L311.444 848.27L319.596 792.032L274.981 756.858L222.22 777.916Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.981 756.858L214.068 834.153L311.444 848.27L274.981 756.858Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.95 760.336L92.7972 816.573L137.406 851.746L190.173 830.689L198.326 774.452L153.71 739.278L100.95 760.336Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.838 841.342L127.285 749.69",
    stroke: "#FF7300",
    strokeWidth: 0.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0765 654.172L59.808 697.413L94.1062 724.46L134.68 708.267L140.949 665.026L106.643 637.978L66.0765 654.172Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.643 637.979L94.1059 724.46",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8079 697.414L140.949 665.027",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.68 708.268L66.0764 654.173",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-73.524 684.694L31.5926 642.74",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4722 698.755L-65.4036 628.679",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.595 689.329L302.327 732.57L336.625 759.617L377.199 743.424L383.467 700.183L349.162 673.135L308.595 689.329Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.162 673.136L336.625 759.617",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.327 732.57L383.468 700.183",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.199 743.424L308.595 689.329",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.674 642.858L213.433 754.889",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.995 719.851L274.112 677.897",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.991 733.912L177.116 663.836",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.739 813.073L456.587 869.311L501.196 904.483L553.963 883.427L562.115 827.189L517.5 792.016L464.739 813.073Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.5 792.016L456.587 869.31L553.963 883.427L517.5 792.016Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.469 795.493L335.316 851.73L379.925 886.903L432.692 865.847L440.845 809.609L396.229 774.436L343.469 795.493Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.259 848.23L699.106 904.468L743.715 939.64L796.475 918.583L804.627 862.346L760.019 827.173L707.259 848.23Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.019 827.173L699.106 904.468L796.475 918.583L760.019 827.173Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.988 830.65L577.836 886.888L622.444 922.061L675.212 901.004L683.364 844.767L638.748 809.593L585.988 830.65Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.876 911.656L612.323 820.005",
    stroke: "#FF7300",
    strokeWidth: 0.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.261 848.953L433.893 812.385",
    stroke: "#FF7300",
    strokeWidth: 0.36,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.115 724.487L544.846 767.727L579.144 794.774L619.718 778.581L625.987 735.341L591.681 708.293L551.115 724.487Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.681 708.293L579.144 794.775",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.846 767.727L625.987 735.34",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.718 778.581L551.115 724.486",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.193 678.016L455.952 790.046",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.514 755.008L516.631 713.054",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.511 769.07L419.635 698.993",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.712 713.173L698.472 825.203",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.034 790.166L759.15 748.212",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.03 804.227L662.154 734.15",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5051 865.057L29.2377 908.291L63.536 935.337L104.11 919.144L110.377 875.911L76.0719 848.863L35.5051 865.057Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0718 848.863L63.5359 935.338",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2377 908.291L110.377 875.912",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.11 919.145L35.5051 865.058",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104.094 895.572L1.02259 853.618",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.09777 909.633L-95.9736 839.557",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.024 900.214L271.757 943.448L306.055 970.495L346.629 954.302L352.896 911.068L318.591 884.02L278.024 900.214Z",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.591 884.021L306.055 970.495",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.104 853.736L182.863 965.767",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.425 930.729L243.542 888.775",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.421 944.79L146.545 874.714",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.623 888.894L425.382 1000.92",
    stroke: "#FF7300",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.369bfab67d56cc72ae3d6ce312208cf5.svg";
export { ForwardRef as ReactComponent };